const toggleClass = (buttonClass, targetClass, classToggle) => {
  const buttons = document.querySelectorAll("." + buttonClass);

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", function (event) {
      event.preventDefault();

      const targetElem = buttons[i].parentNode.querySelector("." + targetClass);

      targetElem.classList.toggle(classToggle);
    });
  }
};

module.exports = { toggleClass };
